export const BUNDLE_OVERRIDE_PARAM = 'bundleOverride';

export const getBundleOverride = (currentUrlSearch: string) => {
  const current = new URLSearchParams(currentUrlSearch);
  return current.get(BUNDLE_OVERRIDE_PARAM);
};

export const buildOverrideSearchParams = (currentUrlSearch: string, targetUrlSearch?: string): URLSearchParams => {
  const target = new URLSearchParams(targetUrlSearch);
  const existingBundleOverride = getBundleOverride(currentUrlSearch);

  if (existingBundleOverride) {
    target.set(BUNDLE_OVERRIDE_PARAM, existingBundleOverride);
  }

  return target;
};
